import {Component, Input, OnInit} from '@angular/core';
import {LangChangeEvent, TranslateModule, TranslateService} from "@ngx-translate/core";
import {MatIcon, MatIconRegistry} from '@angular/material/icon';
import {MatButton} from '@angular/material/button';
import {DatePipe, NgIf, NgOptimizedImage} from '@angular/common';
import {AppointmentModel} from "../../../core/models/appointment.model";
import {PreventDoubleClickDirective} from "../../../shared/directives/prevent-doublic-click-directive";
import {AppointmentService} from "../../services/appointment.service";
import {DomSanitizer} from "@angular/platform-browser";
import {GtmEventDirective} from "../../../shared/directives/gtm-event.directive";
import {SettingsModel} from "../../../core/models/settings.model";
import moment from "moment";

@Component({
  selector: 'appointment-details',
  templateUrl: './appointment-details.component.html',
  styleUrls: ['./appointment-details.component.scss'],
  standalone: true,
  imports: [NgIf, MatIcon, DatePipe, TranslateModule, NgOptimizedImage, PreventDoubleClickDirective, MatButton, GtmEventDirective]
})
export class AppointmentDetailsComponent implements OnInit {

  @Input() appointment!: AppointmentModel;
  @Input() settings: SettingsModel | undefined;
  @Input() locale: string | undefined;
  @Input() hideDate: boolean = false;
  @Input() hideInfo: boolean = false;
  @Input() hideInstallation: boolean = false;
  @Input() hideLocation: boolean = false;
  @Input() hideAddToCalendar: boolean = false;

  showDuration: boolean = false;

  constructor(private translateService: TranslateService,
              private appointmentService: AppointmentService,
              private iconRegistry: MatIconRegistry,
              private sanitizer: DomSanitizer) {
    this.iconRegistry.addSvgIcon(
      'calendar',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/images/icon-calendar.svg')
    );
  }

  ngOnInit() {
    this.locale = this.translateService.currentLang;
    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.locale = event.lang;
    });
    if (this.appointment.duration && this.settings) {
      if (this.appointment.serviceCallType == 'SV01' && this.settings.showDurationForServiceCallTypeSV01) this.showDuration = true;
      if (this.appointment.serviceCallType == 'SV02' && this.settings.showDurationForServiceCallTypeSV02) this.showDuration = true;
      if (this.appointment.serviceCallType == 'SV03' && this.settings.showDurationForServiceCallTypeSV03) this.showDuration = true;
      if (this.appointment.serviceCallType == 'SV04' && this.settings.showDurationForServiceCallTypeSV04) this.showDuration = true;
    }
  }

  addToCalendar() {
    const subject: string = 'Viessmann ' + this.translateService.instant('APPOI.SERVICE_CALL_TYPE.' + this.appointment.serviceCallType)
    const timezone: string = moment.tz.guess();
    this.appointmentService.addToCalendar(this.appointment.id, subject, timezone);
  }
}
